import { getAffiliateInfo, validateStaff } from '@/apis/affiliate';
import { PF_NUMBER_LENGTH } from '@/constants';
import { AgentTypeName } from '@/enums';
import {
  AffiliateResponse,
  AffiliateState,
  StaffResponse,
} from '@/types/Affiliate';
import { ApiResponseWrapper } from '@/types/Wrapper';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: AffiliateState = {
  environmentEntity: '',
  isValid: false,
  isValidStaff: false,
  loading: false,
  isMAEM2U: false,
  isDirectAgent: false,
};

export const affiliateSlice = createSlice({
  name: 'affiliate',
  initialState,
  reducers: {
    setAffiliateId: (state, action: PayloadAction<string | undefined>) => {
      state.agentId = action.payload;
    },
    setProductEntityId: (state, action: PayloadAction<number | undefined>) => {
      state.productEntityId = action.payload;
    },
    setAgentCode: (state, action: PayloadAction<string | undefined>) => {
      state.agentCode = action.payload;
    },
    setAgentBranchCode: (state, action: PayloadAction<string | undefined>) => {
      state.agentBranchCode = action.payload;
    },
    setLeadGenerator: (state, action: PayloadAction<string | undefined>) => {
      state.leadGenerator = action.payload;
    },
    setBancaBranchCode: (state, action: PayloadAction<string | undefined>) => {
      state.bancaBranchCode = action.payload;
    },
    setType: (state, action: PayloadAction<string | undefined>) => {
      state.type = action.payload;
    },
    setSalePFNumber: (state, action: PayloadAction<string | undefined>) => {
      state.salesPfNumber = action.payload;
    },
    setAffiliateEntity: (state, action: PayloadAction<string>) => {
      state.environmentEntity = action.payload;
    },
    resetAffiliate: () => {
      return initialState;
    },
    setClientPfNumber: (state, action: PayloadAction<string | undefined>) => {
      state.clientPfNumber = action.payload;
      if (
        action.payload === undefined ||
        action.payload.length !== PF_NUMBER_LENGTH
      ) {
        state.isValidStaff = false;
      }
    },
    resetClientStaff: (state) => {
      state.clientPfNumber = '';
      state.isValidStaff = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAffiliateInfo.pending, (state) => {
        state.loading = true;
        state.agentCode = undefined;
      })
      .addCase(getAffiliateInfo.fulfilled, (state, action) => {
        state.loading = false;
        const response: ApiResponseWrapper<AffiliateResponse> = action.payload;

        if (!response.succeeded) {
          state.isValid = false;
          state.agentCode = undefined;
          state.agentId = undefined;
          state.productEntity = undefined;
          state.salesPfNumber = undefined;
          state.agentId = '';
          state.salesPfNumber = undefined;
          state.agentBranchCode = undefined;
          state.agentCode = undefined;
          state.type = undefined;
          state.agentName = undefined;
          state.isDirectAgent = false;
        } else {
          state.isValid = true;
          state.agentCode = response.data.agentCode;
          state.productEntity = response.data.productEntity;
          state.bancaBranchCode = response.data.bancaBranchCode;
          state.salesPfNumber = response.data.salesPfNumber;
          state.agentBranchCode = response.data.agentBranchCode;
          state.agentCode = response.data.agentCode;
          state.type = response.data.type;
          state.agentName = response.data.agentName;
          state.isDirectAgent = response.data.isDirectAgent ?? false;
          state.isMAEM2U = response.data.isMAEM2U ?? false;
        }
      })
      .addCase(getAffiliateInfo.rejected, (state) => {
        state.loading = false;
        state.isValid = false;
        state.productEntity = undefined;
        state.agentCode = undefined;
        state.agentId = undefined;
        state.salesPfNumber = undefined;
        state.agentId = '';
        state.agentBranchCode = undefined;
        state.agentCode = undefined;
        state.type = undefined;
        state.agentName = undefined;
        state.isDirectAgent = false;
        state.isMAEM2U = false;
      });

    builder
      .addCase(validateStaff.fulfilled, (state, action) => {
        state.clientPfNumber = action.meta.arg;
        const response: ApiResponseWrapper<StaffResponse> = action.payload;

        if (state.type === AgentTypeName.Banca) {
          if (response.succeeded) {
            state.isValidStaff = response.data.activeIndicator === 'Y';
          } else {
            state.isValidStaff = false;
          }
        }
      })
      .addCase(validateStaff.rejected, (state, action) => {
        state.clientPfNumber = action.meta.arg;
        state.isValidStaff = false;
      });
  },
});

export const {
  resetAffiliate,
  setAffiliateId,
  setAffiliateEntity,
  setAgentBranchCode,
  setAgentCode,
  setBancaBranchCode,
  setClientPfNumber,
  setLeadGenerator,
  setSalePFNumber,
  setType,
  resetClientStaff,
} = affiliateSlice.actions;
export default affiliateSlice.reducer;
